<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Earning from "./earning";
import TopTenItems from './toptenItems'
// import TopTenCustomers from './toptencustomers'

/**
 * Reporting component
 */
export default {
  page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,TopTenItems,Earning },

  data() {
    return {
    };
  },
  methods: {
  }
};
</script>

<template>
  <Layout>

  <div class="row pt-4 pb-4">
    <div class="col-12">
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <Earning :isMonthly="true" :currentMonth="new Date().getMonth()" :currentYear="new Date().getFullYear()" />
        </div>

        <div class="col-md-6 col-xs-12">
          <Earning :isYearly="true" :currentMonth="new Date().getMonth()" :currentYear="new Date().getFullYear()"/>
        </div>
      </div>

      <div class="row">
        <!-- <div class="col-lg-12 col-sm-12 col-xs-12">
          <TopTenCustomers />
        </div> -->
        <div class="col-lg-12 col-sm-12 col-xs-12">
          <TopTenItems />
        </div>
      </div>


    </div>
  </div>
    



  </Layout>
</template>
